import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';

import { downloadDocument, printDocument } from '../../../../store/documents/documents.actions';
import { printCustomsForms } from '../../../../store/printing/print.actions';
import { usePrintSettings } from '../../core/hooks';
import { buildDefaultPrintSetting } from '../../../../containers/print-document-button-containers/core/buildDefaultPrintSetting';
import { DocumentType } from '../../../../enums/document-type';
import PrintDocumentMenuItem from '../../../../components/print-document-menu-item';

export const CustomsForm = ({ selectedData }) => {
  const dispatch = useDispatch();
  const isDisabled = !selectedData.length;
  const fulfillmentIds = useMemo(
    () => selectedData.filter((f) => !!f.fulfillmentId && !f.isLabelVoided).map((f) => f.fulfillmentId),
    [selectedData],
  );
  const fulfillmentPlanIds = useMemo(() => selectedData.map((f) => f.fulfillmentPlanId), [selectedData]);
  const printSettings = usePrintSettings(DocumentType.CustomsForm.printSettingKey);
  const onClick = useCallback(() => {
    dispatch(printCustomsForms(fulfillmentPlanIds));
  }, [dispatch, fulfillmentPlanIds]);
  const onDownload = useCallback(() => {
    dispatch(downloadDocument(DocumentType.CustomsForm, fulfillmentIds));
  }, [dispatch, fulfillmentIds]);
  const onPrint = useCallback(() => {
    dispatch(printDocument(DocumentType.CustomsForm, fulfillmentPlanIds, printSettings));
  }, [dispatch, fulfillmentPlanIds, printSettings]);
  const defaultPrintSetting = useMemo(
    () => buildDefaultPrintSetting(printSettings, onPrint, onDownload),
    [onDownload, onPrint, printSettings],
  );

  return (
    <PrintDocumentMenuItem
      defaultPrintSetting={defaultPrintSetting}
      disabled={isDisabled}
      name={DocumentType.CustomsForm.documentNameTranslation}
      onClick={onClick}
    />
  );
};

CustomsForm.propTypes = {
  selectedData: PropTypes.arrayOf(
    PropTypes.shape({
      fulfillmentId: PropTypes.string.isRequired,
      isLabelVoided: PropTypes.bool,
    }),
  ).isRequired,
};
